module.exports = __webpack_public_path__ + "img/7esty blUE ARABIC@3x.0e289dd1.png";